import * as z from 'zod'

export const paymentCardSchema = z.object({
  brand: z.string(),
  expMonth: z.string(),
  expYear: z.string(),
  id: z.string(),
  last4: z.string(),
  canDelete: z.boolean(),
})

export type PaymentCard = z.infer<typeof paymentCardSchema>
